import React from "react";


export const ContextLang = React.createContext({ contextLang: 'en' });